/**
 * HTTPS enforcement utility.
 *
 * Call `enforceHttps()` once at app startup.
 * In production it redirects HTTP → HTTPS.
 * In development (localhost) it's a no-op.
 */
export function enforceHttps(): void {
  if (typeof window === "undefined") return;

  const { protocol, hostname } = window.location;

  // Skip in local development
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "0.0.0.0"
  ) {
    return;
  }

  // Redirect HTTP to HTTPS in production
  if (protocol === "http:") {
    window.location.href = window.location.href.replace("http:", "https:");
  }
}
